<template>
  	<div class="mb-5">
		<app-button
			v-if="$route.name === 'diagnoses'"
			class="new-poll"
			text="Nuevo"
			@click="goTo('new-diagnosis')"
		/>
		<div v-if="$route.name === 'diagnoses'">
			<v-layout wrap>
				<v-flex xs12 mt-4 mb-5>
					<app-table
						title="DIAGNÓSTICOS"
						:filter-columns="false"
						:rows="rows"
						:columns="columns"
						:main-list="false"
						class="is-not-selectable no-main-list"
						@on-search-event="onSearch"
					>
						<template slot="rows" slot-scope="props">
							<td v-show="showRow(columns, 1)" class="is-not-selectable border-top text-left">{{ props.row.name }}</td>
							<td v-show="showRow(columns, 2)" class="is-not-selectable border-top text-left">{{ props.row.toolName }}</td>
							<td v-show="showRow(columns, 3)" class="border-top">{{props.row.numAnswered}}/{{props.row.numApplicants}}</td>
							<td v-show="showRow(columns, 4)" class="border-top dates">{{ props.row.startDate | formatDate }}</td>
							<td v-show="showRow(columns, 5)" class="border-top dates">{{ props.row.endDate | formatDate }}</td>
							<td v-show="showRow(columns, 6)" class="border-top">
								<app-tooltip-button
									icon="remove_red_eye"
									size="20"
									text="Detalle"
									color="primary"
									@click-icon="goToDetail(props.row)"
								/>
							</td>
						</template>
					</app-table>
				</v-flex>
			</v-layout>
		</div>
		<div v-else>
			<router-view></router-view>
		</div>
  </div>
</template>
<script>
import appButton from '@/components/shared/app-button';

function created() {
	if (this.$route.name === 'diagnoses') {
		this.loadData();
	}
}

async function loadData() {
	const params = {
		search: this.search || null,
	};
	try {
		const { data: response } = await this.$httpPraktiko.get('diagnostic', { params });
		this.rows = response;
	} catch (error) {
		this.showGenericError();
	}
}

function onSearch(searchVal) {
	const newSearch = searchVal ? searchVal.trim() : null;
	this.search = newSearch;
	this.loadData();
}

function goToDetail({ detail, id }) {
	const { toolId } = detail[0];
	this.goTo('detail-diagnoses', { params: { toolId, id } });
}

function data() {
	return {
		columns: [
			{ id: 1, name: 'Nombre de Diagnóstico', visible: true, checked: true },
			{ id: 2, name: 'Herramienta', visible: true, checked: true },
			{ id: 3, name: 'Aplicantes', visible: true, checked: true },
			{ id: 4, name: 'Fecha Inicial', visible: true, checked: true },
			{ id: 5, name: 'Fecha Final', visible: true, checked: true },
			{ id: 6, name: 'Acciones', visible: true, checked: true },
		],
		rows: [],
		search: null,
	};
}

export default {
	name: 'page-diagnosis-diagnoses',
	data,
	created,
	components: {
		appButton,
	},
	methods: {
		loadData,
		onSearch,
		goToDetail,
	},
	watch: {
		$route(newVal) {
			if (newVal.name === 'diagnoses') {
				this.loadData();
			}
		},
	},
};
</script>
<style lang="scss">
.diagnosis-diagnoses {
  .text-left {
		margin-bottom: 0px;
		text-align: left;
	}

	.table-list {
		thead tr:nth-child(2) {
			& th:nth-child(2) {
				text-align: left !important;
			}
		}
	}
}
</style>
<style lang="scss" scoped>
.new-poll {
	border-radius: 6px;
	color: white;
	padding: 7px 17px;
}

.dates {
	white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/diagnosis/page-diagnosis-diagnoses.vue